// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__eetVE","btn-primary":"button_btn-primary__8jQcm","btn-secondary":"button_btn-secondary__YOKBG"};